export enum UrlPath {
	CATEGORY = 'c',
	FAMILY = 'f',
	PRODUCT = 'p',
	STATIC = 's'
}
